module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA0ElEQVR4AWOgC/i/nViE0MAQ5vg/GsQ4nivSq6CJiYDi2DUA5fqUNSbrK3XKaPWpqk/WVZ5uotSjqAEUx6lhtrniimCxbXk8+5tYtxdyrUjiWxAk3KeigVPDUlfZBR6Sm0vZd7czLA0VOVXLe66Za6qeCk4N87zF12Xw3uhnv7+I4dtWhv8HGP7vZZhmqIxTw2QHiRP9TK8WM39ew3izh/PJPJZr3Rz9quo4NUzQUenRUN4YL7wxRrRXU/lEPdfBMt5Jmmo4NeBCFMUDsWhwAgDNJcOsx1ue/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LK.png
// module id = 1193
// module chunks = 0